import React from "react";
import Grid from "@mui/material/GridLegacy";
import FormFooter from "@/modules/lead-page/components/lead-info/edit-fields/status/forms/form-footer";
import useExpoMeetingForm from "@/modules/lead-page/hooks/lead-info/status/forms/expo-meeting-form.hook";
import CommentWithRecordingInput from "@/modules/common/components/audio/CommentWithRecordingInput";

interface ExpoMeetingFormProps {
  handleSaleSubmission: (formattedData: any, formType: "sale" | "form") => void;
  handleClose: () => void;
  isLoadingSubmition: boolean;
}

const ExpoMeetingForm: React.FC<ExpoMeetingFormProps> = ({
  handleSaleSubmission,
  handleClose,
  isLoadingSubmition,
}) => {
  const {
    formControls: { control, errors },
    formHandlers: { onFormSubmit },
    formState: { canSubmit },
    recording,
    commentState,
    computed,
  } = useExpoMeetingForm({
    handleFormSubmission: handleSaleSubmission,
  });

  return (
    <form onSubmit={onFormSubmit}>
      <Grid container spacing={2}>
        <CommentWithRecordingInput
          recording={recording}
          control={control}
          errors={errors}
          commentState={commentState}
          computed={computed}
        />

        <FormFooter
          handleClose={handleClose}
          isLoadingSubmition={isLoadingSubmition}
          confirmText="Save"
          disabled={!canSubmit}
        />
      </Grid>
    </form>
  );
};

export default ExpoMeetingForm;
